// import { Injectable } from '@nestjs/common';
// import { CommonResponse } from '@boi/shared-models';
// import { GoogleTranslator } from '@translate-tools/core/translators';


// @Injectable()
// export class TranslationService {
//     private readonly libretranslateUrl = 'http://165.22.210.69:5111';

//     constructor() { }

//     async translateToHindi(text: string): Promise<CommonResponse> {
//         try {
//             const plainText = this.stripHtmlTags(text);

//             if (!plainText || plainText.trim().length === 0) {
//                 return new CommonResponse(false, 400, 'No text to translate');
//             }

//             console.log('🔄 Translating to Hindi:', plainText.substring(0, 100));

//             // Create abort controller for timeout
//             const controller = new AbortController();
//             const timeoutId = setTimeout(() => controller.abort(), 30000);

//             try {
//                 const response = await fetch(`${this.libretranslateUrl}/translate`, {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json',
//                     },
//                     body: JSON.stringify({
//                         q: plainText,
//                         source: 'en',
//                         target: 'hi',
//                         format: 'text'
//                     }),
//                     signal: controller.signal
//                 });

//                 clearTimeout(timeoutId);

//                 if (!response.ok) {
//                     throw new Error(`Translation service error: ${response.status}`);
//                 }

//                 const data = await response.json();

//                 if (!data.translatedText) {
//                     return new CommonResponse(false, 500, 'Translation failed - no result received');
//                 }

//                 const translatedWithHtml = this.preserveHtmlStructure(text, data.translatedText);

//                 console.log('✅ Translation complete:', data.translatedText.substring(0, 100));

//                 return new CommonResponse(true, 200, 'Translation successful', {
//                     translatedText: translatedWithHtml
//                 });
//             } catch (fetchError) {
//                 clearTimeout(timeoutId);
//                 throw fetchError;
//             }
//         } catch (error) {
//             console.error('❌ Translation error:', error);

//             if (error.name === 'AbortError') {
//                 return new CommonResponse(false, 500, 'Translation timeout - service took too long to respond');
//             }

//             return new CommonResponse(false, 500, `Translation failed: ${error.message}`);
//         }
//     }

//     async healthCheck(): Promise<CommonResponse> {
//         try {
//             // Create abort controller for timeout
//             const controller = new AbortController();
//             const timeoutId = setTimeout(() => controller.abort(), 5000);

//             try {
//                 const response = await fetch(`${this.libretranslateUrl}/health`, {
//                     method: 'GET',
//                     signal: controller.signal
//                 });

//                 clearTimeout(timeoutId);

//                 if (response.ok) {
//                     return new CommonResponse(true, 200, 'Translation service is healthy');
//                 }
//                 return new CommonResponse(false, 503, 'Translation service is unhealthy');
//             } catch (fetchError) {
//                 clearTimeout(timeoutId);
//                 throw fetchError;
//             }
//         } catch (error) {
//             if (error.name === 'AbortError') {
//                 return new CommonResponse(false, 503, 'Translation service health check timeout');
//             }
//             return new CommonResponse(false, 503, `Translation service unavailable: ${error.message}`);
//         }
//     }

//     private stripHtmlTags(html: string): string {
//         if (!html) return '';
//         return html
//             .replace(/<[^>]*>/g, ' ')
//             .replace(/\s+/g, ' ')
//             .trim();
//     }

//     private preserveHtmlStructure(originalHtml: string, translatedText: string): string {
//         if (!originalHtml) return translatedText;

//         const trimmedOriginal = originalHtml.trim();
//         if (trimmedOriginal.startsWith('<p') && trimmedOriginal.endsWith('</p>')) {
//             return `<p>${translatedText}</p>`;
//         }

//         const divMatch = originalHtml.match(/<div([^>]*)>([\s\S]*?)<\/div>/i);
//         if (divMatch && divMatch[0].length === originalHtml.length) {
//             return `<div${divMatch[1]}>${translatedText}</div>`;
//         }

//         return translatedText;
//     }

//     async translateText(text, from, to): Promise<any> {
//         const translator = new GoogleTranslator();
//         try {
//             const result = await translator.translate(text, from, to);
//             console.log(result);
//         } catch (err) {
//             console.log(err);
//         }
//     }

// }













import { Injectable, OnModuleInit } from '@nestjs/common';
import { CommonResponse } from '@boi/shared-models';
import { GoogleTranslator } from '@translate-tools/core/translators/GoogleTranslator';

@Injectable()
export class TranslationService implements OnModuleInit {
    private translator: GoogleTranslator;
    private isTranslatorReady: boolean = false;

    async onModuleInit() {
        // Initialize translator with required headers for Node.js
        this.translator = new GoogleTranslator({
            headers: {
                'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36'
            }
        });
        this.isTranslatorReady = true;
        console.log('✅ Google Translator initialized');
    }

    // Language mapping for Indian languages
    private languageMap = {
        HINDI: 'hi',
        TELUGU: 'te',
        TAMIL: 'ta',
        BENGALI: 'bn',
        MARATHI: 'mr',
        GUJARATI: 'gu',
        KANNADA: 'kn',
        MALAYALAM: 'ml',
        PUNJABI: 'pa',
        ODIA: 'or',
        URDU: 'ur',
        SANSKRIT: 'sa'
    };

    async translateToLanguage(text: string, targetLanguage: string): Promise<CommonResponse> {
        try {
            // Check if translator is ready
            if (!this.isTranslatorReady) {
                return new CommonResponse(false, 503, 'Translator not initialized yet');
            }

            // Remove HTML tags for cleaner translation
            const plainText = this.stripHtmlTags(text);

            if (!plainText || plainText.trim().length === 0) {
                return new CommonResponse(false, 400, 'No text to translate');
            }

            // Get language code
            const targetLang = this.languageMap[targetLanguage.toUpperCase()];
            if (!targetLang) {
                return new CommonResponse(false, 400, `Unsupported language: ${targetLanguage}`);
            }

            console.log(`🔄 Translating to ${targetLanguage}:`, plainText.substring(0, 100));

            // Preserve blanks (underscores) for fill-in-the-blank questions
            const { processedText, blanks } = this.preserveBlanks(plainText);

            // Perform translation
            const translatedText = await this.translator.translate(processedText, 'en', targetLang);

            // Restore blanks
            let finalText = this.restoreBlanks(translatedText, blanks);

            // Clean up extra spaces
            finalText = finalText.replace(/\s+/g, ' ').trim();

            console.log(`✅ ${targetLanguage} translation:`, finalText.substring(0, 100));

            return new CommonResponse(true, 200, `Translation to ${targetLanguage} successful`, {
                translatedText: finalText
            });

        } catch (error) {
            console.error(`❌ Translation error:`, error);
            return new CommonResponse(false, 500, `Translation failed: ${error.message}`);
        }
    }

    async translateToHindi(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'HINDI');
    }

    async translateToTelugu(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'TELUGU');
    }

    async translateToTamil(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'TAMIL');
    }

    async translateToBengali(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'BENGALI');
    }

    async translateToMarathi(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'MARATHI');
    }

    async translateToGujarati(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'GUJARATI');
    }

    async translateToKannada(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'KANNADA');
    }

    async translateToMalayalam(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'MALAYALAM');
    }

    async translateToPunjabi(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'PUNJABI');
    }

    async translateToOdia(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'ODIA');
    }

    async translateToUrdu(text: string): Promise<CommonResponse> {
        return this.translateToLanguage(text, 'URDU');
    }

    async getSupportedLanguages(): Promise<CommonResponse> {
        return new CommonResponse(true, 200, 'Supported languages', {
            languages: Object.keys(this.languageMap)
        });
    }

    private preserveBlanks(text: string): { processedText: string; blanks: string[] } {
        const blanks: string[] = [];
        let processedText = text;
        const matches = text.match(/_{3,}/g);

        if (matches) {
            matches.forEach((match, index) => {
                blanks.push(match);
                processedText = processedText.replace(match, ` [BLANK_${index + 1}] `);
            });
        }

        return { processedText, blanks };
    }

    private restoreBlanks(text: string, blanks: string[]): string {
        let result = text;
        blanks.forEach((blank, index) => {
            const patterns = [`BLANK_${index + 1}`, `Blank ${index + 1}`, `blank ${index + 1}`];
            for (const pattern of patterns) {
                if (result.includes(pattern)) {
                    result = result.replace(new RegExp(pattern, 'gi'), blank);
                    break;
                }
            }
        });
        return result;
    }

    private stripHtmlTags(html: string): string {
        if (!html) return '';
        return html
            .replace(/<[^>]*>/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }
}